
import { runAction } from "../client";

export interface LoginRequest
{
    Username: string;
    Password: string;
}

export interface KeyCloakAuthRequest
{
    AccessCode: string;
}

export interface LoginResult
{
    AuthCookie: string;
    ErrorMessage: string;
    Success: boolean;
    Username?: string;
}

export interface LoginFn
{
    (request: LoginRequest): Promise<LoginResult>;
}

export interface AuthFn
{
    (request: KeyCloakAuthRequest): Promise<LoginResult>;
}

export interface SignOutFn
{
    (): Promise<{}>;
}

export const login: LoginFn = (request: LoginRequest) => {
    return runAction<LoginResult>('/action/AuthenticateUser', request);
};

export const auth: AuthFn = (request: KeyCloakAuthRequest) => {
    return runAction<LoginResult>('/action/AuthenticateKeyCloakToken', request);
};

export const signOut: SignOutFn = () => {
    return runAction<{}>('/action/SignOutUser', {});
};


// WEBPACK FOOTER //
// ./src/rest/Login/index.ts